module.exports = __webpack_public_path__ + "img/history3.55c0d6f5.jpg";